/**
 *
 * OverlayThumb
 *
 */
import React, { memo } from 'react';
import { OverlayThumbWrapper } from './styled';

interface Props {
  icon?: React.ReactNode;
  label?: string;
  children?: React.ReactNode;
}

export const OverlayThumb = memo(({ icon, label, children }: Props) => {
  return (
    <OverlayThumbWrapper>
      <div className="overlay-icon">{icon}</div>
      {label && <div className="overlay-label">{label}</div>}
      {children}
    </OverlayThumbWrapper>
  );
});
